<template>
  <div class="vip-audio-list-component">
    <div class="vip-audio-list"
         v-for="(item, index) in audios"
         :key="index"
    >
      <div class="header"
           :class="{ 'active': currIndex === index }"
           @click="handleToggleCollege(index)"
      >
        <div class="college-name"
             :class="{ 'active': currIndex === index }"
        >
          {{ item.name }} <span class="update-tip">持续更新中</span>
        </div>
        <div class="product-num">
          <span>
            {{ item.count }}门
            <ym-icon class="ym-icon"
                      name="down"
                      :class="{ 'active': currIndex === index }"
            />
          </span>
        </div>
      </div>
      <div class="product-list"
           :class="{ 'active': currIndex === index }"
      >
        <div class="product-item"
             v-for="(productItem, productIndex) in item.list"
             :key="productIndex"
             @click="handleProductDetail(productItem.productType, productItem.id)"
        >
          <div class="product-cover">
            <cover :cover="productItem.cover"
                   :alt="productItem.title"
            />
          </div>
          <div class="product-info">
            <div class="info">
              <h4 class="item-title">{{ productItem.title }}</h4>
              <span class="item-summary">{{ productItem.summary }}</span>
            </div>
            <div class="update-count">已更新{{ productItem.updatedCount }}期</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cover from '@/components/ProductCover';
  import { getProductPath, projectJump } from '@/utils';

  export default {
    name: 'VipAudioList',
    components: {
      Cover,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        currIndex: -1,
      };
    },
    computed: {
      audios() {
        return this.list.filter(item => item.count > 0);
      },
    },
    methods: {
      handleToggleCollege(index) {
        if (this.currIndex === index) {
          this.currIndex = -1;
        } else {
          this.currIndex = index;
        }
      },
      handleProductDetail(type, id) {
        const route = getProductPath(type, id);
        projectJump(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-audio-list-component {
    margin-left: @size-medium;
  }
  .vip-audio-list {
    &:not(:first-child) {
      .header {
        border-top: @border-base;
      }
    }
    &:last-child {
      .header {
        border-bottom: @border-base;
      }
    }
    .header {
      &.active {
        border-bottom: none;
      }
    }
  }
  .product-list {
    .product-item {
      &:not(:first-child) {
        border-top: @border-base;
      }
    }
  }
  .header {
    padding: @size-extra-medium @size-medium @size-extra-medium 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .college-name {
    font-weight: @font-weight-primary;
    font-size: @font-size-medium;
    line-height: 1;
    color: @color-text-base;
    display: flex;
    align-items: flex-end;
    .update-tip {
      margin-left: @size-small;
      font-weight: @font-weight-primary;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
    &.active {
      color: @color-primary;
    }
  }
  .product-num {
    span {
      font-size: @font-size-base;
      color: @color-text-lighter;
    }
    .ym-icon {
      margin-left: @size-extra-small;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .product-list {
    margin-right: @size-medium;
    display: none;
    &.active {
      display: block;
    }
  }
  .product-item {
    padding: @size-base 0;
    display: flex;
  }
  .product-cover {
    margin-right: @size-base;
  }
  .product-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .item-title {
    margin: 0 0 @size-extra-small + @size-extra-small / 2 0;
    font-weight: @font-weight-primary;
    font-size: @font-size-base;
    line-height: 1.4;
    color: @color-text-base;
  }
  .item-summary {
    font-size: @font-size-base;
    line-height: 1;
    color: @color-text-lighter;
  }
  .update-count {
    font-size: @font-size-small;
    line-height: 1;
    color: @color-text-lighter;
  }

</style>
